<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">区域名称：</span>
        <el-input v-model="areaName" :size="size" clearable placeholder="请输入区域名称"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">负责人：</span>
        <el-input v-model="areaAdminName" :size="size" clearable placeholder="请输入负责人"></el-input>
      </div>
      <div class="header_item">
        <el-button v-if="showButton('search')" icon="el-icon-search" @click="searchDistrictList(true)">查询</el-button>
        <el-button class="search_btn" v-if="showButton('insert')" icon="el-icon-plus" @click="propInsert()">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="districtList"
        height="100%" >
        <el-table-column label="序号" width="60" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="areaName" label="区域名称" align="center"></el-table-column>
        <el-table-column prop="areaAdmins" label="负责人" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propUpdate(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加 修改 区域负责人 -->
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '添加区域负责人' : '修改区域负责人信息'"
      :visible.sync="asyncDistrict"
      width="40%">
      <el-form ref="form" :model="formDistrict" :rules="rulesDistrict" label-width="auto" class="rule_form">
        <el-form-item label="区域名称：" prop="areaName">
          <el-input v-model="formDistrict.areaName" :size="size" clearable placeholder="请输入区域名称"></el-input>
        </el-form-item>
        <el-form-item label="负责人：" prop="userIds">
          <el-transfer
            ref="transfer"
            filterable
            filter-placeholder="请输入员工姓名"
            v-model="formDistrict.userIds"
            :data="staffData"
            :titles="['全部负责人', '已选负责人']"
            :props="{
              key: 'userId',
              label: 'realName'
            }">
          </el-transfer>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncDistrict = false">取 消</el-button>
        <el-button class="submit_btn"  @click="asyncTitle ? submitInsertForm() : submitUpdateForm()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { changeSize, throttle } from '../../plugins/public';
import { buttonPinia } from '../../pinia/index';
  export default {
    data() {
      return {
        size: changeSize(),
        areaName: '',
        areaAdminName: '',
        pageNum: 1,
        pageSize: 10,
        total: 0,
        loading: false,
        districtList: [], // 列表信息
        asyncTitle: true, // true 添加区域负责人  false 修改区域负责人信息
        asyncDistrict: false, // 弹窗
        formDistrict: {}, // 表单信息
        rulesDistrict: {
          areaName: [{
            required: true,
            message: '请输入区域名称',
            trigger: 'blur'
          }],
          userIds: [{
            required: true,
            message: '请选择负责人',
            trigger: 'blur'
          }]
        }, // 校验规则
        staffData: [], // 人员信息
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchDistrictList(true);
    },
    methods: {
      // 获取所有人员信息
      async getAllStaffData() {
        const { data } = await this.$api.Personnerl.GETSTAFFALLDATA();
        this.staffData = data;
      },
      // 查询区域负责人列表信息
      searchDistrictList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.loading = true;
        this.districtList = [];
        this.$api.Personnerl.SEARCHDISTRICTLIST({
          areaName: this.areaName,
          areaAdminName: this.areaAdminName,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }).then((res) => {
          if(res.success) {
            this.total = res.data.total;
            this.districtList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 打开添加信息
      propInsert() {
        this.asyncTitle = true;
        this.asyncDistrict = true;
      },
      // 打开修改信息
      propUpdate(row) {
        this.asyncTitle = false;
        this.asyncDistrict = true;
        this.$api.Personnerl.GETDISTRICTINFODATA({
          id: row.id
        }).then((res) => {
          const data = res.data.areaAdminList.map(item => item.userId);
          this.$set(this.formDistrict, 'id', row.id);
          this.$set(this.formDistrict, 'areaName', res.data.areaName);
          this.$set(this.formDistrict, 'userIds', data);
        })
      },
      // 删除区域负责人信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该区域信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Personnerl.DELETEDISTRICTINFO({id: row.id})
        .then(res => {
          if(res.success) {
            this.searchDistrictList(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加负责人信息
      submitInsertForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formDistrict);
            params.userIds = params.userIds.join(',');
            this.$api.Personnerl.INSERTDISTRICTINFO(params).then((res) => {
              if(res.success) {
                this.asyncDistrict = false;
                this.$message.success('添加成功!');
                this.searchDistrictList(true);
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改负责人信息
      submitUpdateForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formDistrict);
            params.userIds = params.userIds.join(',');
            this.$api.Personnerl.UPDATEDISTRICTINFO(params).then((res) => {
              if(res.success) {
                this.asyncDistrict = false;
                this.$message.success('修改成功!');
                this.searchDistrictList(true);
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchDistrictList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchDistrictList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },
    },
    watch: {
      asyncDistrict(bol) {
        if(!bol) {
          this.formDistrict = {};
          this.$refs.form.resetFields();
          this.$refs.transfer.clearQuery('left');
          this.$refs.transfer.clearQuery('right');
        } else {
          this.getAllStaffData();
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
@import '../../style/layout-main.scss';
</style>